import { useEffect, useState } from "react";

import { useFormContext } from "react-hook-form";

import { config } from "@/config";
import {
  IIRatingsAndReviewsResponse,
  IIServiceProviderDetail,
  IIServiceProviderDetailWithPricing,
  IIServiceProviderRatingAndReview,
  IV1ServiceProviderDetailsRatingReviewsGetRequest,
  IV1ServiceProviderDetailsSessionIdGetRequest,
  v1ServiceProviderDetailsRatingReviewsGet,
  v1ServiceProviderDetailsSessionIdGet,
} from "@/contract/generated/electrify-v1";
import { useApi } from "@/hooks/useApi";
import { isError } from "@/utils";
import { getSessionId } from "@/utils/sessionId";

export type IServiceProviderDetails = Array<IIServiceProviderDetail>;

export const useServiceProviderDetails = () => {
  const { call } = useApi();
  const { getValues } = useFormContext();
  const [providerDetails, setProviderDetails] =
    useState<IServiceProviderDetails>([]);

  const [serviceProviderDetails, setServiceProviderDetails] = useState<
    any[] | Error
  >([]);

  useEffect(() => {
    if (providerDetails && providerDetails.length > 3) {
      const firstThreeProviderDetails = providerDetails.slice(0, 3);
      setProviderDetails(firstThreeProviderDetails);
    }
  }, [providerDetails]);

  const getRecommendedServiceProviderDetails = async (): Promise<
    IIServiceProviderDetail[]
  > => {
    const data: IV1ServiceProviderDetailsSessionIdGetRequest = {
      sessionId: getSessionId(),
      systemSize: getValues("selectedSystemSize"),
      systemType: getValues("systemType"),
      degradedExperience: getValues("degradedExperience"),
    };

    const response = await call(() =>
      v1ServiceProviderDetailsSessionIdGet(config.apiBasePath, data)
    );

    if (isError(response)) {
      throw response;
    }

    return response as IIServiceProviderDetailWithPricing[];
  };

  const getRecommendedServiceProviderDetailReviews = async (
    serviceProviderIds: string
  ): Promise<IIServiceProviderRatingAndReview[]> => {
    const data: IV1ServiceProviderDetailsRatingReviewsGetRequest = {
      serviceProviderIds,
    };

    const response = await call(() =>
      v1ServiceProviderDetailsRatingReviewsGet(config.apiBasePath, data)
    );

    if (isError(response)) {
      throw response;
    }

    return (response as IIRatingsAndReviewsResponse).ratingsAndReviews;
  };

  return {
    providerDetails,
    setProviderDetails,
    serviceProviderDetails,
    setServiceProviderDetails,
    getRecommendedServiceProviderDetails,
    getRecommendedServiceProviderDetailReviews,
  };
};
